import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_metronic/layout/_core/MetronicLayout";
import { Header } from "./Menu/Header";
import { HeaderMobile } from "../../../_metronic/layout/components/header-mobile/HeaderMobile";
import { Aside } from "../../../_metronic/layout/components/aside/Aside";
import { Footer } from "../../../_metronic/layout/components/footer/Footer";
import { LayoutInit } from "../../../_metronic/layout/components/LayoutInit";
import { SubHeader } from "../../../_metronic/layout/components/subheader/SubHeader";
import { QuickPanel } from "../../../_metronic/layout/components/extras/offcanvas/QuickPanel";
import { QuickUser } from "../../../_metronic/layout/components/extras/offcanvas/QuickUser";
import { ScrollTop } from "../../../_metronic/layout/components/extras/ScrollTop";
import { AnimateLoading } from "../../../_metronic/_partials/controls";

export function Layout({ children }) {
  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  return layoutProps.selfLayout !== "blank" ? (
    <>
      <AnimateLoading />
      <HeaderMobile />

      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-row flex-column-fluid page">
          <div
            className="d-flex flex-column flex-row-fluid wrapper"
            id="kt_wrapper"
          >
            <Header />
            <div
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
            >
              {layoutProps.subheaderDisplay && <SubHeader />}
              {layoutProps.contentExtended && (
                <>
                  {layoutProps.asideDisplay && (
                    <div className="d-lg-flex flex-row-fluid">
                      <Aside />
                      <div className="content-wrapper">{children}</div>
                    </div>
                  )}

                  {!layoutProps.asideDisplay && <>{children}</>}
                </>
              )}

              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  <div className={layoutProps.contentContainerClasses}>
                    {layoutProps.asideDisplay && (
                      <div className="d-lg-flex flex-row-fluid">
                        <Aside />
                        <div className="content-wrapper flex-row-fluid">
                          {children}
                        </div>
                      </div>
                    )}
                    {!layoutProps.asideDisplay && <>{children}</>}
                  </div>
                </div>
              )}
            </div>
            <Footer />
          </div>
        </div>
      </div>
      <LayoutInit />
      <ScrollTop />
      <QuickPanel />
      <QuickUser admin />
    </>
  ) : (
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
